export {
  PDFPreview,
  PDFPreviewProps,
} from '@roc/ui';